// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import "@hotwired/turbo-rails"
import "./controllers"

// Bootstrap Toast Notification System
window.showToast = function(message, type = 'info') {
  const container = document.getElementById('toast-container');
  if (!container) return;

  // Map flash types to Bootstrap classes
  const typeMap = {
    'success': 'bg-success text-white',
    'notice': 'bg-success text-white',
    'error': 'bg-danger text-white',
    'alert': 'bg-warning text-dark',
    'warning': 'bg-warning text-dark',
    'info': 'bg-info text-white'
  };

  // Get appropriate icon and title based on type
  const { icon, title } = getToastConfig(type);
  
  // Create Bootstrap toast element
  const toast = document.createElement('div');
  toast.className = `toast show ${typeMap[type] || typeMap.info}`;
  toast.setAttribute('role', 'alert');
  toast.setAttribute('aria-live', 'assertive');
  toast.setAttribute('aria-atomic', 'true');
  
  // Create toast HTML using Bootstrap structure
  toast.innerHTML = `
    <div class="toast-header">
      <i class="fas ${icon} me-2"></i>
      <strong class="me-auto">${title}</strong>
      <button type="button" class="btn-close btn-close-white" aria-label="Close"></button>
    </div>
    <div class="toast-body">
      ${message}
    </div>
  `;
  
  // Add to container
  container.appendChild(toast);
  
  // Auto-remove after appropriate delay
  const autoRemoveDelay = type === 'error' || type === 'alert' ? 8000 : 6000;
  
  const autoRemoveTimer = setTimeout(() => {
    if (toast.parentNode) {
      dismissToast(toast);
    }
  }, autoRemoveDelay);
  
  // Add close button functionality
  const closeBtn = toast.querySelector('.btn-close');
  closeBtn.addEventListener('click', function(e) {
    e.stopPropagation();
    clearTimeout(autoRemoveTimer);
    dismissToast(toast);
  });
  
  // Add click to dismiss functionality (but not on close button)
  toast.addEventListener('click', function(e) {
    if (!e.target.closest('.btn-close')) {
      clearTimeout(autoRemoveTimer);
      dismissToast(toast);
    }
  });
  
  return toast;
};

// Helper function to dismiss toast with fade-out animation
function dismissToast(toast) {
  // Add fade-out animation
  toast.classList.add('fade-out');
  
  setTimeout(() => {
    if (toast.parentNode) {
      toast.remove();
    }
  }, 400);
}

// Helper function to get toast configuration
function getToastConfig(type) {
  const configs = {
    success: { icon: 'fa-check-circle', title: 'Success' },
    notice: { icon: 'fa-check-circle', title: 'Success' },
    error: { icon: 'fa-exclamation-triangle', title: 'Error' },
    alert: { icon: 'fa-exclamation-triangle', title: 'Warning' },
    warning: { icon: 'fa-exclamation-triangle', title: 'Warning' },
    info: { icon: 'fa-info-circle', title: 'Information' }
  };
  
  return configs[type] || configs.info;
}

// Make showToast available globally for flash messages
window.addEventListener('DOMContentLoaded', function() {
  // This ensures the function is available when flash messages try to call it
  window.showToast = window.showToast;
});
